var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGcmIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 129 129",
    fill: "#b1cbff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5 129C100.122 129 129 100.122 129 64.5C129 28.8776 100.122 0 64.5 0C28.8776 0 0 28.8776 0 64.5C0 100.122 28.8776 129 64.5 129Z",
    fill: "#b1cbff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5012 52.5923C67.0456 52.5923 69.1427 54.9865 69.4293 58.0709L69.4627 58.7942L69.4627 96.0057C69.4627 99.431 67.2414 102.208 64.5012 102.208C61.9567 102.208 59.8596 99.8135 59.573 96.729L59.5396 96.0057L59.5396 58.7942C59.5396 55.369 61.761 52.5923 64.5012 52.5923Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5012 42.6692C67.2414 42.6692 69.4627 40.4478 69.4627 37.7076C69.4627 34.9675 67.2414 32.7461 64.5012 32.7461C61.761 32.7461 59.5397 34.9675 59.5397 37.7076C59.5397 40.4478 61.761 42.6692 64.5012 42.6692Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcmIssue);
export default __webpack_public_path__ + "static/media/gcm-issue.56bf75db.svg";
export { ForwardRef as ReactComponent };